import React, { useEffect, useState } from 'react';
import { Form, Row, Col, Select, InputNumber, Button } from 'antd';
import { toast } from 'react-toastify';
import apiRequest from '../../hooks/ApiRequest';

const { Option } = Select;

const ManageEmailEventForm = ({ form, eventId, modalVisible, onSuccess }) => {
  const { getFieldDecorator, setFieldsValue, resetFields } = form;
  const [templateList, setTemplateList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(null);
  const userId = localStorage.getItem('loggedInUserID');
  const moduleList = [  
    { name: 'Policy', id: 1 },
    { name: 'Claim', id: 2 },
  ]
  console.log('userId', userId);

  const fetchEmailTemplates = async () => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_EMAIL}/Email/get-template`,
        'GET'
      );
      if (res.success) {
        setTemplateList(res.data);
      } else {
        toast.error(res.message || 'Failed to load email templates');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error fetching templates');
    }
  };


  const fetchEventById = async (id) => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_CLAIM}/api/EmailEvent/${id}`,
        'GET'
      );

      if (res) {
        const data = res.data;
        setId(data.id);
        setFieldsValue({
          moduleName: data.moduleName,
          moduleId: data.moduleId,
          activity: data.activity,
          event: data.event,
          period: data.period,
          templateId: data.templateId,
          insurerId: data.insurerId
        });
      } else {
        toast.error('No event found');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error fetching event');
    }
  };

  useEffect(() => {
    fetchEmailTemplates();
    if (eventId) {
      fetchEventById(eventId);
    } else {
      resetFields();
    }
  }, [eventId]);

  const handleSubmit = e => {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (err) return;
      setLoading(true);

      const selectedModule = moduleList.find(mod => mod.name === values.moduleName);
      const templateName = templateList.find(mod => mod.id === values.templateId);


      const payload = {
        ...values,
        id: id || 0,
        moduleId: selectedModule?.id,
        templateName: templateName?.name || 'test',
        insurerId: values.insurerId || parseInt(localStorage.getItem('loggedInUserID'), 10)
      };

      const url = id
        ? `${process.env.REACT_APP_BASE_URL_CLAIM}/api/EmailEvent/${id}` // Update
        : `${process.env.REACT_APP_BASE_URL_CLAIM}/api/EmailEvent`; // Create

      try {
        const res = await apiRequest(url, 'POST', payload);

        if (res && (res.success || res.data)) {
          toast.success(eventId ? 'Email Event updated' : 'Email Event created');
          if (onSuccess) onSuccess();
        } else {
          toast.error(res?.message || 'Something went wrong');
        }
      } catch (err) {
        console.error(err);
        toast.error('Request failed');
      } finally {
        setLoading(false);
      }
    });
  };



  return (
    <Form layout="vertical" onSubmit={handleSubmit}>
      <Row gutter={16}>
        <Col md={8}>
          <Form.Item label="Module Name">
            {getFieldDecorator('moduleName', {
              rules: [{ required: true, message: 'Please select module' }],
            })(
              <Select placeholder="Select Module">
                {moduleList && moduleList?.map((ele) => (
                  <Option value={ele?.name}>{ele?.name}</Option>
                ))
                }
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col md={8}>
          <Form.Item label="Email Template">
            {getFieldDecorator('templateId', {
              rules: [{ required: false, message: 'Please select template' }],
            })(
              <Select placeholder="Select Email Template">
                {templateList.map(temp => (
                  <Option key={temp.id} value={temp.id}>
                    {temp.name}
                  </Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>

        <Col md={8}>
          <Form.Item label="Event">
            {getFieldDecorator('event', {
              rules: [{ required: true, message: 'Please select event' }],
            })(
              <Select placeholder="Select Event">
                <Option value="Before">Before</Option>
                <Option value="After">After</Option>
              </Select>
            )}
          </Form.Item>
        </Col>

        <Col md={8}>
          <Form.Item label="Activity">
            {getFieldDecorator('activity', {
              rules: [{ required: true, message: 'Please select activity' }],
            })(
              <Select placeholder="Select Activity">
                <Option value="Add">Add</Option>
                <Option value="Update">Update</Option>
                <Option value="Renew">Renew</Option>
                <Option value="Expiry">Expiry</Option>
              </Select>
            )}
          </Form.Item>
        </Col>

        <Col md={8}>
          <Form.Item label="Period (in days)">
            {getFieldDecorator('period', {
              rules: [{ required: true, message: 'Please input period' }],
            })(
              <InputNumber min={0} placeholder="e.g., 4" style={{ width: '100%' }} />
            )}
          </Form.Item>
        </Col>
      </Row>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          {id ? 'Update Email Event' : 'Create Email Event'}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Form.create({ name: 'manage_email_event_form' })(ManageEmailEventForm);